export const SCHOLARSHIP = 'scholarship' as const;
export const INCENTIVE = 'incentive' as const;

export type PaymentRequestTypeValue = typeof SCHOLARSHIP | typeof INCENTIVE;

export type PaymentRequestType = {
  label: string;
  value: PaymentRequestTypeValue;
};

export const PAYMENT_TYPES: PaymentRequestType[] = [
  { label: 'Scholarship', value: SCHOLARSHIP },
  { label: 'Incentive', value: INCENTIVE },
];

export const DEFAULT_PAYMENT_TYPE: PaymentRequestTypeValue = SCHOLARSHIP;
